import { memo } from 'react'
import { Link } from 'react-router-dom'

export const Footer = memo(function Footer() {
  return (
    <footer className="bg-surface border-t border-border py-8 sm:py-12 px-4 sm:px-6" role="contentinfo">
      <div className="container-custom">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold text-text mb-3 sm:mb-4">Softitect AI</h3>
            <p className="text-sm text-text-muted">
              The cost optimization layer for your AI stack. One API, all models, less spend.
            </p>
          </div>

          {/* Links */}
          <nav aria-label="Footer navigation">
            <h3 className="text-base sm:text-lg font-semibold text-text mb-3 sm:mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/documentation" className="text-sm link">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm link">
                  Pricing
                </Link>
              </li>
              <li>
                <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-sm link">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-sm link">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </nav>

          {/* Contact */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-base sm:text-lg font-semibold text-text mb-3 sm:mb-4">Contact</h3>
            <p className="text-sm text-text-muted mb-2">
              Have questions? Get in touch.
            </p>
            <a 
              href="mailto:support@softitect.com" 
              className="text-sm link break-all"
              aria-label="Email support at support@softitect.com"
            >
              support@softitect.com
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-border text-center">
          <p className="text-xs sm:text-sm text-text-muted">
            © {new Date().getFullYear()} Softitect AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
})
